import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-product__amount _fc _flex-basis-33"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "gfu-product__amount-input" }
const _hoisted_5 = {
  class: "gfu-product__submit _flex-basis-66",
  "data-qa": "add-product-to-cart-section"
}
const _hoisted_6 = { class: "gfu-btn__text" }
const _hoisted_7 = { class: "gfu-btn__text" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "gfu-btn__text" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "gfu-btn__text" }
const _hoisted_13 = { class: "gfu-btn__text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_number_field = _resolveComponent("number-field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", null, [
    ($options.isExtended && $data.productData)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['gfu-product__amount-wrapper', $props.wrapperClassList])
        }, [
          ($props.showQuantityInput && !$options.effectiveReadonly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                  class: "gfu-product__amount-btn gfu-product__amount-btn--plus gfu-btn gfu-btn--icon gfu-btn--primary",
                  type: "button",
                  "aria-label": _ctx.Resources.Product.QuantityInputIncreaseButtonLabel,
                  onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($options.changeQuantity(1)), ["prevent"])),
                  "data-qa": "add-product-to-cart-button:Plus"
                }, [
                  _createVNode(_component_base_icon, { name: "plus" })
                ], 8 /* PROPS */, _hoisted_2),
                _createElementVNode("button", {
                  class: "gfu-product__amount-btn gfu-product__amount-btn--minus gfu-btn gfu-btn--icon gfu-btn--primary",
                  type: "button",
                  "aria-label": _ctx.Resources.Product.QuantityInputDecreaseButtonLabel,
                  onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.changeQuantity(-1)), ["prevent"])),
                  "data-qa": "add-product-to-cart-button:Minus"
                }, [
                  _createVNode(_component_base_icon, { name: "minus" })
                ], 8 /* PROPS */, _hoisted_3),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_number_field, {
                    modelValue: $options.effectiveQuantity,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($options.effectiveQuantity) = $event)),
                    class: "_mt-0",
                    name: "model.quantity",
                    "display-name": _ctx.Resources.Product.QuantityInputLabel,
                    "label-class": "_sr-only",
                    integer: true,
                    min: "1",
                    "validator-layout": "none",
                    onEnter: $options.displayProductSetOrSubmit,
                    "data-qa": "add-product-to-cart-quantity"
                  }, null, 8 /* PROPS */, ["modelValue", "display-name", "onEnter"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_5, [
            ($options.isDisabled)
              ? (_openBlock(), _createBlock(_component_tooltip, {
                  key: 0,
                  text: $options.tooltipMessage,
                  "data-qa": "add-product-to-cart-button-tooltip"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_button, {
                      class: _normalizeClass($options.buttonClasses),
                      enabled: false,
                      display: "block",
                      theme: "disabled",
                      "data-qa": "add-product-to-cart-button:AddToCart"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, _toDisplayString($props.buttonText), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["class"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["text"]))
              : (_openBlock(), _createBlock(_component_base_button, {
                  key: 1,
                  class: _normalizeClass([$options.buttonClasses]),
                  theme: $options.buttonTheme,
                  display: "block",
                  onClick: _withModifiers($options.displayProductSetOrSubmit, ["prevent"]),
                  "data-qa": "add-product-to-cart-button:AddToCart"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_7, _toDisplayString($props.buttonText), 1 /* TEXT */),
                    ($props.showIcon)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass([$options.getIconPositionClass(), '_ga _ga--plus-bold-icon'])
                        }, null, 2 /* CLASS */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["class", "theme", "onClick"]))
          ])
        ], 2 /* CLASS */))
      : ($options.isDisabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            ($options.tooltipMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_tooltip, {
                    class: "gfu-1of1",
                    text: $options.tooltipMessage,
                    "show-on-init": $data.forceShowTooltip,
                    "data-qa": "add-product-to-cart-button-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_base_button, {
                        class: _normalizeClass($options.buttonClasses),
                        enabled: false,
                        display: "block",
                        theme: "disabled",
                        "data-qa": "add-product-to-cart-button:AddToCart"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_10, _toDisplayString($props.buttonText), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["class"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["text", "show-on-init"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_base_button, {
                    class: _normalizeClass($options.buttonClasses),
                    enabled: false,
                    display: "block",
                    theme: "disabled",
                    "data-qa": "add-product-to-cart-button:AddToCart"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_12, _toDisplayString($props.buttonText), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["class"])
                ]))
          ]))
        : (_openBlock(), _createBlock(_component_base_button, {
            key: 2,
            class: _normalizeClass([$options.buttonClasses, 'add-product-button-marker']),
            display: "block",
            theme: $options.buttonTheme,
            onClick: _withModifiers($options.displayOptionsOrSubmit, ["prevent"]),
            "data-qa": "add-product-to-cart-button:AddToCart"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "buttonContents", {}, () => [
                _createElementVNode("span", _hoisted_13, _toDisplayString($props.buttonText), 1 /* TEXT */),
                ($props.showIcon)
                  ? (_openBlock(), _createBlock(_component_base_icon, {
                      key: 0,
                      name: "plus-bold-icon",
                      class: _normalizeClass([$options.getIconPositionClass()]),
                      "icon-namespace": "ga"
                    }, null, 8 /* PROPS */, ["class"]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["class", "theme", "onClick"])),
    _createVNode(_component_progress_overlay, {
      visible: _ctx.isProcessing,
      sticky: true
    }, null, 8 /* PROPS */, ["visible"])
  ]))
}